import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  Button,
  Badge,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { CSVExport } from "react-bootstrap-table2-toolkit"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import * as equipmentAction from "../../store/emdPcGVyYXRpb25z/actions"
import SimpleReactValidator from "simple-react-validator"
import { isEmpty } from "lodash"
import { toast, ToastContainer } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"

const EquipmentZGOperations = (props) => {
  const { dispatch, searchBtnStyle } = props
  const title = "Equipment ZG Operations"

  //Search and vaidations
  const { SearchBar } = Search
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  //Export downlaod options
  const { ExportCSVButton } = CSVExport

  //Initial Loading
  useEffect(() => {
    dispatch(equipmentAction.loadRecordsMetaData())
    dispatch(equipmentAction.loadRecords())
  }, [])
  //Store data from reducer
  const update = useSelector((specificstate) => specificstate.zgOperations)
  const { recordsMetaData = {}, records = [] } = update
  const sessionUpdate = useSelector((state) => state.session)
  const { user = {} } = sessionUpdate
  const authUser = localStorage.getItem("authUser")
  console.log("update is", update)
  //Data setting section
  const responseLogin = JSON.parse(authUser)

  const dateSetting =
    !isEmpty(responseLogin) &&
    responseLogin.setting &&
    responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //Data setting section end
  console.log(recordsMetaData, "recordMetaData")

  //Handle Change
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [equipmentType, setEquipmentType] = useState([])
  const [equipmentBrand, setEquipmentBrand] = useState([])
  const [equipmentProduct, setEquipmentProduct] = useState([])
  const [serialNo, setSerialNo] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)

  //Service modal
  const [openDialog, setOpenDialog] = useState(false)
  const [serviceHistory, setServiceHistory] = useState(false)
  const [serviceHistoryDetails, setServiceHistoryDetails] = useState("")
  const [serviceDetails, setServiceDetails] = useState("")
  const [remarks, setRemarks] = useState("")
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        status: "active",
        mode: "HR",
      }
  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )

  //Fuse options

  const fuseOptions = {
    keys: ["serialNo", "label"],
  }
  const handleApply = (e) => {
    e.preventDefault()
    var searchCompany = company && company.value ? company.value : ""
    var searchBranch = branch && branch.value ? branch.value : ""
    var searchType =
      equipmentType && equipmentType.value ? equipmentType.value : ""
    var searchBrand =
      equipmentBrand && equipmentBrand.value ? equipmentBrand.value : ""
    var searchProduct =
      equipmentProduct && equipmentProduct.value ? equipmentProduct.value : ""
    var searchSerialNo = serialNo && serialNo.value ? serialNo.value : ""

    var searchFilter = {}
    searchFilter.status = "active"
    searchFilter.mode = "ZG OPERATIONS"
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchSerialNo) {
      searchFilter.serialNumber = searchSerialNo
    }
    if (searchType) {
      searchFilter.equipmentTypeId = searchType
    }
    if (searchBrand) {
      searchFilter.equipmentBrandId = searchBrand
    }
    if (searchProduct) {
      searchFilter.productVersionId = searchProduct
    }
    setSearchValueList(searchFilter)
    dispatch(equipmentAction.loadRecords(searchFilter))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  console.log(serialNo, "serialNo")
  //table data

  let slNo = 0
  const equipmentTable = !isEmpty(records)
    ? records.map((equipment) => {
        slNo = slNo + 1
        console.log(equipment, "equipment from mapped list")

        const equipmentSerialCount =
          !isEmpty(searchValueList.serialNumber) &&
          !isEmpty(equipment) &&
          equipment.details.length > 0
            ? equipment.details.filter(
                (data) => data.serialNumber == searchValueList.serialNumber
              )
            : ""
        const equipmentCount =
          isEmpty(searchValueList.serialNumber) &&
          !isEmpty(equipment) &&
          equipment.details &&
          equipment.details.length > 0
            ? equipment.details.length
            : !isEmpty(searchValueList.serialNumber)
            ? equipmentSerialCount.length
            : 0

        console.log(equipmentCount, "equipmentCount")
        console.log(equipmentSerialCount, "equipmentSerialCount")
        //const BrandName=
        return {
          sNo: slNo,
          _id: equipment._id,
          companyName: equipment.companyName,
          companyId: equipment.companyId,
          branchId: equipment.branchId,
          branchName: equipment.branchName,
          serialNumber: equipment.serialNumber,
          isService: (
            <button
              className={
                equipment.isService === true
                  ? "btn btn-success"
                  : "btn btn-danger"
              }
              onClick={() => {
                setServiceDetails(equipment)
                setOpenDialog(true)
                setRemarks("")
              }}
            >
              {equipment.isService === true ? "Yes" : "No"}
            </button>
          ),
          equipment: (
            <div className="space-between">
              <span className="badge rounded-pill bg-primary">
                {equipmentCount}
              </span>
            </div>
          ),
          equipmentName: equipment.equipmentName,
          equipmentCode: equipment.equipmentCode,
          equipmentMode: equipment.mode,
          equipments: equipment.details,
          brandName: equipment.equipmentBrandName,
          productName: equipment.productVersionName,
          equipmentType: equipment.equipmentTypeName,
          productVersion: equipment.productVersionName,
        }
      })
    : []

  const today = moment().format("YYYY-MM-DD")

  const serviceConfirm = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const record = {
        issues: remarks,
        equipmentId: serviceDetails.equipmentId,
        serviceDate: today,
        // isService: serviceDetails.isService === false ? true : false,
      }
      console.log(record, "service Details")
      dispatch(equipmentAction.updateServiceAccess(record))
      setTimeout(() => {
        setOpenDialog(false)
        toast.success("Records Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        dispatch(equipmentAction.loadRecords(searchValue))
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setOpenDialog(true)
    }
  }

  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "equipment",
      text: "Details Count",
      sort: true,
      // csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "equipmentType",
      text: "Equipment Type",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "productName",
      text: "Product",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "brandName",
      text: "Brand",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  const options = {
    sizePerPage: 10,
    totalSize: records.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const [equipmentRemoveId, setEquipmentRemoveId] = useState("")
  //Delete section
  const [deleteModal, setDeleteModal] = useState(false)

  const deleteEquipment = () => {
    const deleteData = {
      equipmentId: equipmentRemoveId,
      status: 3,
    }
    console.log(deleteData, "deleted")
    dispatch(equipmentAction.deleteRecord(deleteData))
    setTimeout(() => {
      dispatch(equipmentAction.loadRecords(searchValue))
      toast.success("Records Deleted Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setDeleteModal(false)
    }, 1000)
  }

  console.log(serviceDetails, "serviceDetails")
  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                S.No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Action
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Equipment Code
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Serial No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Is Service
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Employee
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Attachment
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.equipments.length > 0 ? (
              row.equipments.map((data, index) => {
                const attachment =
                  data && !isEmpty(data.attachment) ? data.attachment : ""
                console.log(attachment, "attachment")
                const fileUrl = isEmpty(attachment)
                  ? ""
                  : attachment.substring(attachment.indexOf("/"))
                console.log(fileUrl, "string attachments")
                const attachments = isEmpty(fileUrl)
                  ? ""
                  : "https://api.alphaone.app/uploads/" + fileUrl
                console.log(attachments, "attachment with alpha url")
                const employeeName =
                  !isEmpty(data) && data.employee ? data.employee.join(",") : []
                const equipmentMaster =
                  !isEmpty(data) && data.equipmentMaster
                    ? data.equipmentMaster
                    : []
                if (
                  searchValueList.serialNumber == equipmentMaster.serialNumber
                ) {
                  return (
                    <tr key={data._id}>
                      <td scope="data">{index + 1}</td>
                      <td>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              setDeleteModal(true)
                              setEquipmentRemoveId(data._id)
                            }}
                            style={{ fontSize: "10px" }}
                            className="btn btn-danger buttons"
                          >
                            <i
                              className="fas fa-trash-alt icon-btn"
                              style={{ fontSize: "12px" }}
                            ></i>
                          </Button>
                        </div>
                      </td>
                      <td>{equipmentMaster.equipmentCode}</td>
                      <td>{equipmentMaster.serialNumber}</td>
                      <td>
                        <div className="d-flex flex-row">
                          <div>
                            <button
                              className={
                                equipmentMaster.isService === true
                                  ? "btn btn-success disabled-button"
                                  : "btn btn-danger"
                              }
                              onClick={() => {
                                setServiceDetails(data)
                                setOpenDialog(true)
                                setRemarks("")
                              }}
                            >
                              {equipmentMaster.isService === true
                                ? "Yes"
                                : "No"}
                            </button>
                          </div>
                          <div className="mt-2">
                            <p
                              className="mx-2"
                              style={{
                                textDecoration: "underline",
                                color: "#50a5f1",
                              }}
                              onClick={() => {
                                setServiceHistoryDetails(
                                  equipmentMaster.serviceDetails
                                )
                                setServiceHistory(true)
                              }}
                            >
                              History
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>{employeeName}</td>
                      <td>
                        {!isEmpty(attachment) ? (
                          <div className="mt-2">
                            <a
                              onClick={() => window.open(attachments, "_blank")}
                            >
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "#E40D8C",
                                }}
                              >
                                View
                              </span>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )
                } else if (isEmpty(searchValueList.serialNumber)) {
                  return (
                    <tr key={data._id}>
                      <td scope="data">{index + 1}</td>
                      <td>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              setDeleteModal(true)
                              setEquipmentRemoveId(data._id)
                            }}
                            style={{ fontSize: "10px" }}
                            className="btn btn-danger buttons"
                          >
                            <i
                              className="fas fa-trash-alt icon-btn"
                              style={{ fontSize: "12px" }}
                            ></i>
                          </Button>
                        </div>
                      </td>
                      <td>{equipmentMaster.equipmentCode}</td>
                      <td>{equipmentMaster.serialNumber}</td>
                      <td>
                        <div className="d-flex flex-row">
                          <div>
                            <button
                              className={
                                equipmentMaster.isService === true
                                  ? "btn btn-success disabled-button"
                                  : "btn btn-danger"
                              }
                              onClick={() => {
                                setServiceDetails(data)
                                setOpenDialog(true)
                                setRemarks("")
                              }}
                            >
                              {equipmentMaster.isService === true
                                ? "Yes"
                                : "No"}
                            </button>
                          </div>
                          <div className="mt-2">
                            <p
                              className="mx-2"
                              style={{
                                textDecoration: "underline",
                                color: "#50a5f1",
                              }}
                              onClick={() => {
                                setServiceHistoryDetails(
                                  equipmentMaster.serviceDetails
                                )
                                setServiceHistory(true)
                              }}
                            >
                              History
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>{employeeName}</td>
                      <td>
                        {!isEmpty(attachment) ? (
                          <div className="mt-2">
                            <a
                              onClick={() => window.open(attachments, "_blank")}
                            >
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "#E40D8C",
                                }}
                              >
                                View
                              </span>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //Reset functionality
  const [resetManager, setResetManager] = useState(false)
  const resetFormDetails = () => {
    setCompany([])
    setBranch([])
    setEquipmentBrand([])
    setEquipmentProduct([])
    setEquipmentType([])
    setSearchValueList({})
    setResetManager(true)
    setTimeout(()=> {
      setResetManager(false)
    }, 0)
    setSerialNo([])
    dispatch(equipmentAction.loadRecords())
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Inventory"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => setCompany(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        value={branch}
                        onChange={(e) => setBranch(e)}
                        options={branchListOptions}
                        placeholder="Select branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Type"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentType"
                        value={equipmentType}
                        onChange={(e) => setEquipmentType(e)}
                        options={
                          recordsMetaData ? recordsMetaData.typeOptions : []
                        }
                        placeholder="Select Equipment"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Brand"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentBrand"
                        value={equipmentBrand}
                        onChange={(e) => setEquipmentBrand(e)}
                        options={
                          recordsMetaData ? recordsMetaData.brandOptions : []
                        }
                        placeholder="Select Equipment Brand"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Product Version"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentProduct"
                        value={equipmentProduct}
                        onChange={(e) => setEquipmentProduct(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productOptions : []
                        }
                        placeholder="Select Product Version"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Serial No"}</Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="serialNo"
                        key={resetManager}
                        items={recordsMetaData.equipmentMasterListOptions}
                        value={serialNo}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setSerialNo(e)}
                        onChange={(e) => setSerialNo(e.target.value)}
                        placeholder="Enter Serial No"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleApply(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={equipmentTable}
                      columns={columns}
                      search
                      exportCSV={{
                        onlyExportFiltered: true,
                        exportAll: false,
                      }}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col>
                                <ExportCSVButton
                                  className="border float-right mx-10"
                                  style={{
                                    float: "right",
                                    backgroundColor: "#e40d8c",
                                    color: "#ffffff",
                                  }}
                                  {...props.csvProps}
                                >
                                  Download{" "}
                                </ExportCSVButton>{" "}
                              </Col>
                              <Col md="12" lg="12" xl="12" sm="12" xs="12">
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  keyField="equipment"
                                  bordered={true}
                                  columns={columns}
                                  expandRow={expandRow}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {openDialog && (
          <Modal show={openDialog} scrollable={true} backdrop={"static"}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Do you want to Active the Service?
            </Modal.Header>
            <div className="modal-body">
              <Col lg="12" md="12" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Department"}>
                    {"Issues"} <span className="mx-1 required">*</span>
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter Issue Details"
                  className="employee-crowd-textArea"
                />
                {simpleValidator.current.message(
                  "Remarks",
                  remarks,
                  "required"
                )}
              </Col>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                style={{ height: "46px" }}
                className="btn btn-light"
                onClick={() => setOpenDialog(false)}
              >
                Close
              </button>
              <button
                type="button"
                style={{ height: "46px" }}
                className="btn btn-primary"
                onClick={(e) => {
                  serviceConfirm(e)
                }}
              >
                Confirm
              </button>
            </div>
          </Modal>
        )}
        {deleteModal && (
          <Modal
            show={deleteModal}
            size="md"
            style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>Do You Want To Delete this record?</Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    setDeleteModal(false)
                  }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    deleteEquipment()
                  }}
                  style={{ marginLeft: "20px" }}
                  className="btn btn-success buttons"
                >
                  {" "}
                  Confirm
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {serviceHistory && (
          <Modal
            show={serviceHistory}
            size="lg"
            style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Service History
            </Modal.Header>
            <Modal.Body>
              {" "}
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Service Date</th>
                    <th>Service Given Date</th>
                    <th>Issues</th>
                    <th>Expected Date</th>
                    <th>Vendor Name</th>
                    <th>Remarks</th>
                    <th>Estimate</th>
                    <th>Service Status</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(serviceHistoryDetails) &&
                  serviceHistoryDetails.length > 0 ? (
                    serviceHistoryDetails.map((service, index) => {
                      return (
                        <tr key={service._id}>
                          <td>{index + 1}</td>
                          <td>
                            {!isEmpty(service.serviceDate)
                              ? moment(service.serviceDate).format(dateFormate)
                              : "--"}
                          </td>
                          <td>
                            {!isEmpty(service.serviceGivenDate)
                              ? moment(service.serviceGivenDate).format(
                                  dateFormate
                                )
                              : "--"}
                          </td>
                          <td>
                            {!isEmpty(service.issues) ? service.issues : "--"}
                          </td>
                          <td>
                            {" "}
                            {!isEmpty(service.expectedDate)
                              ? moment(service.expectedDate).format(dateFormate)
                              : "--"}
                          </td>
                          <td>
                            {!isEmpty(service.serviceVendorName)
                              ? service.serviceVendorName
                              : "--"}
                          </td>
                          <td>
                            {" "}
                            {!isEmpty(service.remarks) ? service.remarks : "--"}
                          </td>
                          <td>
                            {" "}
                            {!isEmpty(service.estimate)
                              ? service.estimate
                              : "--"}
                          </td>
                          <td>
                            <Badge
                              className={`font-size-13 badge rounded-pill ${
                                service.servcieStatus === "1" ||
                                service.servcieStatus === "completed"
                                  ? "bg-success badge-soft-success"
                                  : "bg-danger badge-soft-danger"
                              }`}
                              pill
                            >
                              {(!isEmpty(service.servcieStatus) &&
                                service.servcieStatus === "1") ||
                              (!isEmpty(service.servcieStatus) &&
                                service.servcieStatus === "completed")
                                ? "Completed"
                                : service.servcieStatus === "trash"
                                ? "Trash"
                                : "--"}
                            </Badge>{" "}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr key={0}>
                      <td colSpan={7} className="text-align-center">
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    setServiceHistory(false)
                  }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  Close
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
EquipmentZGOperations.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  //isInvalid:PropTypes.any
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentZGOperations)
)
